/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(872);


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global window, global*/
	var util = __webpack_require__(93)
	var assert = __webpack_require__(87)
	function now() { return new Date().getTime() }
	
	var slice = Array.prototype.slice
	var console
	var times = {}
	
	if (typeof global !== "undefined" && global.console) {
	    console = global.console
	} else if (typeof window !== "undefined" && window.console) {
	    console = window.console
	} else {
	    console = {}
	}
	
	var functions = [
	    [log, "log"],
	    [info, "info"],
	    [warn, "warn"],
	    [error, "error"],
	    [time, "time"],
	    [timeEnd, "timeEnd"],
	    [trace, "trace"],
	    [dir, "dir"],
	    [consoleAssert, "assert"]
	]
	
	for (var i = 0; i < functions.length; i++) {
	    var tuple = functions[i]
	    var f = tuple[0]
	    var name = tuple[1]
	
	    if (!console[name]) {
	        console[name] = f
	    }
	}
	
	module.exports = console
	
	function log() {}
	
	function info() {
	    console.log.apply(console, arguments)
	}
	
	function warn() {
	    console.log.apply(console, arguments)
	}
	
	function error() {
	    console.warn.apply(console, arguments)
	}
	
	function time(label) {
	    times[label] = now()
	}
	
	function timeEnd(label) {
	    var time = times[label]
	    if (!time) {
	        throw new Error("No such label: " + label)
	    }
	
	    delete times[label]
	    var duration = now() - time
	    console.log(label + ": " + duration + "ms")
	}
	
	function trace() {
	    var err = new Error()
	    err.name = "Trace"
	    err.message = util.format.apply(null, arguments)
	    console.error(err.stack)
	}
	
	function dir(object) {
	    console.log(util.inspect(object) + "\n")
	}
	
	function consoleAssert(expression) {
	    if (!expression) {
	        var arr = slice.call(arguments, 1)
	        assert.ok(false, util.format.apply(null, arr))
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(5);
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(90);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(89);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(88);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(23), __webpack_require__(7)))

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, console) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(92);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(91);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(23), __webpack_require__(7)))

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1062);
	
	__webpack_require__(1130);
	
	__webpack_require__(886);

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

	'use strict';
	
	function openInquiryWindow(url) {
	  window.open(url, 'inquiry', 'width=980, height=800, menubar=no, toolbar=no, scrollbars=yes');
	}
	window.openInquiryWindow = openInquiryWindow;

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {/**
	 * Intro.js v2.9.3
	 * https://github.com/usablica/intro.js
	 *
	 * Copyright (C) 2017 Afshin Mehrabani (@afshinmeh)
	 */
	
	(function(f) {
	    if (true) {
	        module.exports = f();
	        // deprecated function
	        // @since 2.8.0
	        module.exports.introJs = function () {
	          console.warn('Deprecated: please use require("intro.js") directly, instead of the introJs method of the function');
	          // introJs()
	          return f().apply(this, arguments);
	        };
	    } else if (typeof define === "function" && define.amd) {
	        define([], f);
	    } else {
	        var g;
	        if (typeof window !== "undefined") {
	            g = window;
	        } else if (typeof global !== "undefined") {
	            g = global;
	        } else if (typeof self !== "undefined") {
	            g = self;
	        } else {
	            g = this;
	        }
	        g.introJs = f();
	    }
	})(function () {
	  //Default config/variables
	  var VERSION = '2.9.3';
	
	  /**
	   * IntroJs main class
	   *
	   * @class IntroJs
	   */
	  function IntroJs(obj) {
	    this._targetElement = obj;
	    this._introItems = [];
	
	    this._options = {
	      /* Next button label in tooltip box */
	      nextLabel: 'Next &rarr;',
	      /* Previous button label in tooltip box */
	      prevLabel: '&larr; Back',
	      /* Skip button label in tooltip box */
	      skipLabel: 'Skip',
	      /* Done button label in tooltip box */
	      doneLabel: 'Done',
	      /* Hide previous button in the first step? Otherwise, it will be disabled button. */
	      hidePrev: false,
	      /* Hide next button in the last step? Otherwise, it will be disabled button. */
	      hideNext: false,
	      /* Default tooltip box position */
	      tooltipPosition: 'bottom',
	      /* Next CSS class for tooltip boxes */
	      tooltipClass: '',
	      /* CSS class that is added to the helperLayer */
	      highlightClass: '',
	      /* Close introduction when pressing Escape button? */
	      exitOnEsc: true,
	      /* Close introduction when clicking on overlay layer? */
	      exitOnOverlayClick: true,
	      /* Show step numbers in introduction? */
	      showStepNumbers: true,
	      /* Let user use keyboard to navigate the tour? */
	      keyboardNavigation: true,
	      /* Show tour control buttons? */
	      showButtons: true,
	      /* Show tour bullets? */
	      showBullets: true,
	      /* Show tour progress? */
	      showProgress: false,
	      /* Scroll to highlighted element? */
	      scrollToElement: true,
	      /*
	       * Should we scroll the tooltip or target element?
	       *
	       * Options are: 'element' or 'tooltip'
	       */
	      scrollTo: 'element',
	      /* Padding to add after scrolling when element is not in the viewport (in pixels) */
	      scrollPadding: 30,
	      /* Set the overlay opacity */
	      overlayOpacity: 0.8,
	      /* Precedence of positions, when auto is enabled */
	      positionPrecedence: ["bottom", "top", "right", "left"],
	      /* Disable an interaction with element? */
	      disableInteraction: false,
	      /* Set how much padding to be used around helper element */
	      helperElementPadding: 10,
	      /* Default hint position */
	      hintPosition: 'top-middle',
	      /* Hint button label */
	      hintButtonLabel: 'Got it',
	      /* Adding animation to hints? */
	      hintAnimation: true,
	      /* additional classes to put on the buttons */
	      buttonClass: "introjs-button"
	    };
	  }
	
	  /**
	   * Initiate a new introduction/guide from an element in the page
	   *
	   * @api private
	   * @method _introForElement
	   * @param {Object} targetElm
	   * @param {String} group
	   * @returns {Boolean} Success or not?
	   */
	  function _introForElement(targetElm, group) {
	    var allIntroSteps = targetElm.querySelectorAll("*[data-intro]"),
	        introItems = [];
	
	    if (this._options.steps) {
	      //use steps passed programmatically
	      _forEach(this._options.steps, function (step) {
	        var currentItem = _cloneObject(step);
	
	        //set the step
	        currentItem.step = introItems.length + 1;
	
	        //use querySelector function only when developer used CSS selector
	        if (typeof (currentItem.element) === 'string') {
	          //grab the element with given selector from the page
	          currentItem.element = document.querySelector(currentItem.element);
	        }
	
	        //intro without element
	        if (typeof (currentItem.element) === 'undefined' || currentItem.element === null) {
	          var floatingElementQuery = document.querySelector(".introjsFloatingElement");
	
	          if (floatingElementQuery === null) {
	            floatingElementQuery = document.createElement('div');
	            floatingElementQuery.className = 'introjsFloatingElement';
	
	            document.body.appendChild(floatingElementQuery);
	          }
	
	          currentItem.element  = floatingElementQuery;
	          currentItem.position = 'floating';
	        }
	
	        currentItem.scrollTo = currentItem.scrollTo || this._options.scrollTo;
	
	        if (typeof (currentItem.disableInteraction) === 'undefined') {
	          currentItem.disableInteraction = this._options.disableInteraction;
	        }
	
	        if (currentItem.element !== null) {
	          introItems.push(currentItem);
	        }        
	      }.bind(this));
	
	    } else {
	      //use steps from data-* annotations
	      var elmsLength = allIntroSteps.length;
	      var disableInteraction;
	      
	      //if there's no element to intro
	      if (elmsLength < 1) {
	        return false;
	      }
	
	      _forEach(allIntroSteps, function (currentElement) {
	        
	        // PR #80
	        // start intro for groups of elements
	        if (group && (currentElement.getAttribute("data-intro-group") !== group)) {
	          return;
	        }
	
	        // skip hidden elements
	        if (currentElement.style.display === 'none') {
	          return;
	        }
	
	        var step = parseInt(currentElement.getAttribute('data-step'), 10);
	
	        if (typeof (currentElement.getAttribute('data-disable-interaction')) !== 'undefined') {
	          disableInteraction = !!currentElement.getAttribute('data-disable-interaction');
	        } else {
	          disableInteraction = this._options.disableInteraction;
	        }
	
	        if (step > 0) {
	          introItems[step - 1] = {
	            element: currentElement,
	            intro: currentElement.getAttribute('data-intro'),
	            step: parseInt(currentElement.getAttribute('data-step'), 10),
	            tooltipClass: currentElement.getAttribute('data-tooltipclass'),
	            highlightClass: currentElement.getAttribute('data-highlightclass'),
	            position: currentElement.getAttribute('data-position') || this._options.tooltipPosition,
	            scrollTo: currentElement.getAttribute('data-scrollto') || this._options.scrollTo,
	            disableInteraction: disableInteraction
	          };
	        }
	      }.bind(this));
	
	      //next add intro items without data-step
	      //todo: we need a cleanup here, two loops are redundant
	      var nextStep = 0;
	
	      _forEach(allIntroSteps, function (currentElement) {
	        
	        // PR #80
	        // start intro for groups of elements
	        if (group && (currentElement.getAttribute("data-intro-group") !== group)) {
	          return;
	        }
	        
	        if (currentElement.getAttribute('data-step') === null) {
	
	          while (true) {
	            if (typeof introItems[nextStep] === 'undefined') {
	              break;
	            } else {
	              nextStep++;
	            }
	          } 
	
	          if (typeof (currentElement.getAttribute('data-disable-interaction')) !== 'undefined') {
	            disableInteraction = !!currentElement.getAttribute('data-disable-interaction');
	          } else {
	            disableInteraction = this._options.disableInteraction;
	          }
	
	          introItems[nextStep] = {
	            element: currentElement,
	            intro: currentElement.getAttribute('data-intro'),
	            step: nextStep + 1,
	            tooltipClass: currentElement.getAttribute('data-tooltipclass'),
	            highlightClass: currentElement.getAttribute('data-highlightclass'),
	            position: currentElement.getAttribute('data-position') || this._options.tooltipPosition,
	            scrollTo: currentElement.getAttribute('data-scrollto') || this._options.scrollTo,
	            disableInteraction: disableInteraction
	          };
	        }
	      }.bind(this));
	    }
	
	    //removing undefined/null elements
	    var tempIntroItems = [];
	    for (var z = 0; z < introItems.length; z++) {
	      if (introItems[z]) {
	        // copy non-falsy values to the end of the array
	        tempIntroItems.push(introItems[z]);  
	      } 
	    }
	
	    introItems = tempIntroItems;
	
	    //Ok, sort all items with given steps
	    introItems.sort(function (a, b) {
	      return a.step - b.step;
	    });
	
	    //set it to the introJs object
	    this._introItems = introItems;
	
	    //add overlay layer to the page
	    if(_addOverlayLayer.call(this, targetElm)) {
	      //then, start the show
	      _nextStep.call(this);
	
	      if (this._options.keyboardNavigation) {
	        DOMEvent.on(window, 'keydown', _onKeyDown, this, true);
	      }
	      //for window resize
	      DOMEvent.on(window, 'resize', _onResize, this, true);
	    }
	    return false;
	  }
	
	  function _onResize () {
	    this.refresh.call(this);
	  }
	
	  /**
	  * on keyCode:
	  * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
	  * This feature has been removed from the Web standards.
	  * Though some browsers may still support it, it is in
	  * the process of being dropped.
	  * Instead, you should use KeyboardEvent.code,
	  * if it's implemented.
	  *
	  * jQuery's approach is to test for
	  *   (1) e.which, then
	  *   (2) e.charCode, then
	  *   (3) e.keyCode
	  * https://github.com/jquery/jquery/blob/a6b0705294d336ae2f63f7276de0da1195495363/src/event.js#L638
	  *
	  * @param type var
	  * @return type
	  */
	  function _onKeyDown (e) {
	    var code = (e.code === null) ? e.which : e.code;
	
	    // if code/e.which is null
	    if (code === null) {
	      code = (e.charCode === null) ? e.keyCode : e.charCode;
	    }
	    
	    if ((code === 'Escape' || code === 27) && this._options.exitOnEsc === true) {
	      //escape key pressed, exit the intro
	      //check if exit callback is defined
	      _exitIntro.call(this, this._targetElement);
	    } else if (code === 'ArrowLeft' || code === 37) {
	      //left arrow
	      _previousStep.call(this);
	    } else if (code === 'ArrowRight' || code === 39) {
	      //right arrow
	      _nextStep.call(this);
	    } else if (code === 'Enter' || code === 13) {
	      //srcElement === ie
	      var target = e.target || e.srcElement;
	      if (target && target.className.match('introjs-prevbutton')) {
	        //user hit enter while focusing on previous button
	        _previousStep.call(this);
	      } else if (target && target.className.match('introjs-skipbutton')) {
	        //user hit enter while focusing on skip button
	        if (this._introItems.length - 1 === this._currentStep && typeof (this._introCompleteCallback) === 'function') {
	            this._introCompleteCallback.call(this);
	        }
	
	        _exitIntro.call(this, this._targetElement);
	      } else if (target && target.getAttribute('data-stepnumber')) {
	        // user hit enter while focusing on step bullet
	        target.click();
	      } else {
	        //default behavior for responding to enter
	        _nextStep.call(this);
	      }
	
	      //prevent default behaviour on hitting Enter, to prevent steps being skipped in some browsers
	      if(e.preventDefault) {
	        e.preventDefault();
	      } else {
	        e.returnValue = false;
	      }
	    }
	  }
	
	 /*
	   * makes a copy of the object
	   * @api private
	   * @method _cloneObject
	  */
	  function _cloneObject(object) {
	      if (object === null || typeof (object) !== 'object' || typeof (object.nodeType) !== 'undefined') {
	        return object;
	      }
	      var temp = {};
	      for (var key in object) {
	        if (typeof(window.jQuery) !== 'undefined' && object[key] instanceof window.jQuery) {
	          temp[key] = object[key];
	        } else {
	          temp[key] = _cloneObject(object[key]);
	        }
	      }
	      return temp;
	  }
	  /**
	   * Go to specific step of introduction
	   *
	   * @api private
	   * @method _goToStep
	   */
	  function _goToStep(step) {
	    //because steps starts with zero
	    this._currentStep = step - 2;
	    if (typeof (this._introItems) !== 'undefined') {
	      _nextStep.call(this);
	    }
	  }
	
	  /**
	   * Go to the specific step of introduction with the explicit [data-step] number
	   *
	   * @api private
	   * @method _goToStepNumber
	   */
	  function _goToStepNumber(step) {
	    this._currentStepNumber = step;
	    if (typeof (this._introItems) !== 'undefined') {
	      _nextStep.call(this);
	    }
	  }
	
	  /**
	   * Go to next step on intro
	   *
	   * @api private
	   * @method _nextStep
	   */
	  function _nextStep() {
	    this._direction = 'forward';
	
	    if (typeof (this._currentStepNumber) !== 'undefined') {
	      _forEach(this._introItems, function (item, i) {
	        if( item.step === this._currentStepNumber ) {
	          this._currentStep = i - 1;
	          this._currentStepNumber = undefined;
	        }
	      }.bind(this));
	    }
	
	    if (typeof (this._currentStep) === 'undefined') {
	      this._currentStep = 0;
	    } else {
	      ++this._currentStep;
	    }
	
	    var nextStep = this._introItems[this._currentStep];
	    var continueStep = true;
	
	    if (typeof (this._introBeforeChangeCallback) !== 'undefined') {
	      continueStep = this._introBeforeChangeCallback.call(this, nextStep.element);
	    }
	
	    // if `onbeforechange` returned `false`, stop displaying the element
	    if (continueStep === false) {
	      --this._currentStep;
	      return false;
	    }
	
	    if ((this._introItems.length) <= this._currentStep) {
	      //end of the intro
	      //check if any callback is defined
	      if (typeof (this._introCompleteCallback) === 'function') {
	        this._introCompleteCallback.call(this);
	      }
	      _exitIntro.call(this, this._targetElement);
	      return;
	    }
	
	    _showElement.call(this, nextStep);
	  }
	
	  /**
	   * Go to previous step on intro
	   *
	   * @api private
	   * @method _previousStep
	   */
	  function _previousStep() {
	    this._direction = 'backward';
	
	    if (this._currentStep === 0) {
	      return false;
	    }
	
	    --this._currentStep;
	
	    var nextStep = this._introItems[this._currentStep];
	    var continueStep = true;
	
	    if (typeof (this._introBeforeChangeCallback) !== 'undefined') {
	      continueStep = this._introBeforeChangeCallback.call(this, nextStep.element);
	    }
	
	    // if `onbeforechange` returned `false`, stop displaying the element
	    if (continueStep === false) {
	      ++this._currentStep;
	      return false;
	    }
	
	    _showElement.call(this, nextStep);
	  }
	
	  /**
	   * Update placement of the intro objects on the screen
	   * @api private
	   */
	  function _refresh() {
	    // re-align intros
	    _setHelperLayerPosition.call(this, document.querySelector('.introjs-helperLayer'));
	    _setHelperLayerPosition.call(this, document.querySelector('.introjs-tooltipReferenceLayer'));
	    _setHelperLayerPosition.call(this, document.querySelector('.introjs-disableInteraction'));
	
	    // re-align tooltip
	    if(this._currentStep !== undefined && this._currentStep !== null) {
	      var oldHelperNumberLayer = document.querySelector('.introjs-helperNumberLayer'),
	        oldArrowLayer        = document.querySelector('.introjs-arrow'),
	        oldtooltipContainer  = document.querySelector('.introjs-tooltip');
	      _placeTooltip.call(this, this._introItems[this._currentStep].element, oldtooltipContainer, oldArrowLayer, oldHelperNumberLayer);
	    }
	
	    //re-align hints
	    _reAlignHints.call(this);
	    return this;
	  }
	
	  /**
	   * Exit from intro
	   *
	   * @api private
	   * @method _exitIntro
	   * @param {Object} targetElement
	   * @param {Boolean} force - Setting to `true` will skip the result of beforeExit callback
	   */
	  function _exitIntro(targetElement, force) {
	    var continueExit = true;
	
	    // calling onbeforeexit callback
	    //
	    // If this callback return `false`, it would halt the process
	    if (this._introBeforeExitCallback !== undefined) {
	      continueExit = this._introBeforeExitCallback.call(this);
	    }
	
	    // skip this check if `force` parameter is `true`
	    // otherwise, if `onbeforeexit` returned `false`, don't exit the intro
	    if (!force && continueExit === false) return;
	
	    //remove overlay layers from the page
	    var overlayLayers = targetElement.querySelectorAll('.introjs-overlay');
	
	    if (overlayLayers && overlayLayers.length) {
	      _forEach(overlayLayers, function (overlayLayer) {
	        overlayLayer.style.opacity = 0;
	        window.setTimeout(function () {
	          if (this.parentNode) {
	            this.parentNode.removeChild(this);
	          }
	        }.bind(overlayLayer), 500);
	      }.bind(this));
	    }
	
	    //remove all helper layers
	    var helperLayer = targetElement.querySelector('.introjs-helperLayer');
	    if (helperLayer) {
	      helperLayer.parentNode.removeChild(helperLayer);
	    }
	
	    var referenceLayer = targetElement.querySelector('.introjs-tooltipReferenceLayer');
	    if (referenceLayer) {
	      referenceLayer.parentNode.removeChild(referenceLayer);
	    }
	
	    //remove disableInteractionLayer
	    var disableInteractionLayer = targetElement.querySelector('.introjs-disableInteraction');
	    if (disableInteractionLayer) {
	      disableInteractionLayer.parentNode.removeChild(disableInteractionLayer);
	    }
	
	    //remove intro floating element
	    var floatingElement = document.querySelector('.introjsFloatingElement');
	    if (floatingElement) {
	      floatingElement.parentNode.removeChild(floatingElement);
	    }
	
	    _removeShowElement();
	
	    //remove `introjs-fixParent` class from the elements
	    var fixParents = document.querySelectorAll('.introjs-fixParent');
	    _forEach(fixParents, function (parent) {
	      _removeClass(parent, /introjs-fixParent/g);
	    });
	
	    //clean listeners
	    DOMEvent.off(window, 'keydown', _onKeyDown, this, true);
	    DOMEvent.off(window, 'resize', _onResize, this, true);
	
	    //check if any callback is defined
	    if (this._introExitCallback !== undefined) {
	      this._introExitCallback.call(this);
	    }
	
	    //set the step to zero
	    this._currentStep = undefined;
	  }
	
	  /**
	   * Render tooltip box in the page
	   *
	   * @api private
	   * @method _placeTooltip
	   * @param {HTMLElement} targetElement
	   * @param {HTMLElement} tooltipLayer
	   * @param {HTMLElement} arrowLayer
	   * @param {HTMLElement} helperNumberLayer
	   * @param {Boolean} hintMode
	   */
	  function _placeTooltip(targetElement, tooltipLayer, arrowLayer, helperNumberLayer, hintMode) {
	    var tooltipCssClass = '',
	        currentStepObj,
	        tooltipOffset,
	        targetOffset,
	        windowSize,
	        currentTooltipPosition;
	
	    hintMode = hintMode || false;
	
	    //reset the old style
	    tooltipLayer.style.top        = null;
	    tooltipLayer.style.right      = null;
	    tooltipLayer.style.bottom     = null;
	    tooltipLayer.style.left       = null;
	    tooltipLayer.style.marginLeft = null;
	    tooltipLayer.style.marginTop  = null;
	
	    arrowLayer.style.display = 'inherit';
	
	    if (typeof(helperNumberLayer) !== 'undefined' && helperNumberLayer !== null) {
	      helperNumberLayer.style.top  = null;
	      helperNumberLayer.style.left = null;
	    }
	
	    //prevent error when `this._currentStep` is undefined
	    if (!this._introItems[this._currentStep]) return;
	
	    //if we have a custom css class for each step
	    currentStepObj = this._introItems[this._currentStep];
	    if (typeof (currentStepObj.tooltipClass) === 'string') {
	      tooltipCssClass = currentStepObj.tooltipClass;
	    } else {
	      tooltipCssClass = this._options.tooltipClass;
	    }
	
	    tooltipLayer.className = ('introjs-tooltip ' + tooltipCssClass).replace(/^\s+|\s+$/g, '');
	    tooltipLayer.setAttribute('role', 'dialog');
	
	    currentTooltipPosition = this._introItems[this._currentStep].position;
	
	    // Floating is always valid, no point in calculating
	    if (currentTooltipPosition !== "floating") { 
	      currentTooltipPosition = _determineAutoPosition.call(this, targetElement, tooltipLayer, currentTooltipPosition);
	    }
	
	    var tooltipLayerStyleLeft;
	    targetOffset  = _getOffset(targetElement);
	    tooltipOffset = _getOffset(tooltipLayer);
	    windowSize    = _getWinSize();
	
	    _addClass(tooltipLayer, 'introjs-' + currentTooltipPosition);
	
	    switch (currentTooltipPosition) {
	      case 'top-right-aligned':
	        arrowLayer.className      = 'introjs-arrow bottom-right';
	
	        var tooltipLayerStyleRight = 0;
	        _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer);
	        tooltipLayer.style.bottom    = (targetOffset.height +  20) + 'px';
	        break;
	
	      case 'top-middle-aligned':
	        arrowLayer.className      = 'introjs-arrow bottom-middle';
	
	        var tooltipLayerStyleLeftRight = targetOffset.width / 2 - tooltipOffset.width / 2;
	
	        // a fix for middle aligned hints
	        if (hintMode) {
	          tooltipLayerStyleLeftRight += 5;
	        }
	
	        if (_checkLeft(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, tooltipLayer)) {
	          tooltipLayer.style.right = null;
	          _checkRight(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, windowSize, tooltipLayer);
	        }
	        tooltipLayer.style.bottom = (targetOffset.height + 20) + 'px';
	        break;
	
	      case 'top-left-aligned':
	      // top-left-aligned is the same as the default top
	      case 'top':
	        arrowLayer.className = 'introjs-arrow bottom';
	
	        tooltipLayerStyleLeft = (hintMode) ? 0 : 15;
	
	        _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer);
	        tooltipLayer.style.bottom = (targetOffset.height +  20) + 'px';
	        break;
	      case 'right':
	        tooltipLayer.style.left = (targetOffset.width + 20) + 'px';
	        if (targetOffset.top + tooltipOffset.height > windowSize.height) {
	          // In this case, right would have fallen below the bottom of the screen.
	          // Modify so that the bottom of the tooltip connects with the target
	          arrowLayer.className = "introjs-arrow left-bottom";
	          tooltipLayer.style.top = "-" + (tooltipOffset.height - targetOffset.height - 20) + "px";
	        } else {
	          arrowLayer.className = 'introjs-arrow left';
	        }
	        break;
	      case 'left':
	        if (!hintMode && this._options.showStepNumbers === true) {
	          tooltipLayer.style.top = '15px';
	        }
	
	        if (targetOffset.top + tooltipOffset.height > windowSize.height) {
	          // In this case, left would have fallen below the bottom of the screen.
	          // Modify so that the bottom of the tooltip connects with the target
	          tooltipLayer.style.top = "-" + (tooltipOffset.height - targetOffset.height - 20) + "px";
	          arrowLayer.className = 'introjs-arrow right-bottom';
	        } else {
	          arrowLayer.className = 'introjs-arrow right';
	        }
	        tooltipLayer.style.right = (targetOffset.width + 20) + 'px';
	
	        break;
	      case 'floating':
	        arrowLayer.style.display = 'none';
	
	        //we have to adjust the top and left of layer manually for intro items without element
	        tooltipLayer.style.left   = '50%';
	        tooltipLayer.style.top    = '50%';
	        tooltipLayer.style.marginLeft = '-' + (tooltipOffset.width / 2)  + 'px';
	        tooltipLayer.style.marginTop  = '-' + (tooltipOffset.height / 2) + 'px';
	
	        if (typeof(helperNumberLayer) !== 'undefined' && helperNumberLayer !== null) {
	          helperNumberLayer.style.left = '-' + ((tooltipOffset.width / 2) + 18) + 'px';
	          helperNumberLayer.style.top  = '-' + ((tooltipOffset.height / 2) + 18) + 'px';
	        }
	
	        break;
	      case 'bottom-right-aligned':
	        arrowLayer.className      = 'introjs-arrow top-right';
	
	        tooltipLayerStyleRight = 0;
	        _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer);
	        tooltipLayer.style.top    = (targetOffset.height +  20) + 'px';
	        break;
	
	      case 'bottom-middle-aligned':
	        arrowLayer.className      = 'introjs-arrow top-middle';
	
	        tooltipLayerStyleLeftRight = targetOffset.width / 2 - tooltipOffset.width / 2;
	
	        // a fix for middle aligned hints
	        if (hintMode) {
	          tooltipLayerStyleLeftRight += 5;
	        }
	
	        if (_checkLeft(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, tooltipLayer)) {
	          tooltipLayer.style.right = null;
	          _checkRight(targetOffset, tooltipLayerStyleLeftRight, tooltipOffset, windowSize, tooltipLayer);
	        }
	        tooltipLayer.style.top = (targetOffset.height + 20) + 'px';
	        break;
	
	      // case 'bottom-left-aligned':
	      // Bottom-left-aligned is the same as the default bottom
	      // case 'bottom':
	      // Bottom going to follow the default behavior
	      default:
	        arrowLayer.className = 'introjs-arrow top';
	
	        tooltipLayerStyleLeft = 0;
	        _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer);
	        tooltipLayer.style.top    = (targetOffset.height +  20) + 'px';
	    }
	  }
	
	  /**
	   * Set tooltip left so it doesn't go off the right side of the window
	   *
	   * @return boolean true, if tooltipLayerStyleLeft is ok.  false, otherwise.
	   */
	  function _checkRight(targetOffset, tooltipLayerStyleLeft, tooltipOffset, windowSize, tooltipLayer) {
	    if (targetOffset.left + tooltipLayerStyleLeft + tooltipOffset.width > windowSize.width) {
	      // off the right side of the window
	      tooltipLayer.style.left = (windowSize.width - tooltipOffset.width - targetOffset.left) + 'px';
	      return false;
	    }
	    tooltipLayer.style.left = tooltipLayerStyleLeft + 'px';
	    return true;
	  }
	
	  /**
	   * Set tooltip right so it doesn't go off the left side of the window
	   *
	   * @return boolean true, if tooltipLayerStyleRight is ok.  false, otherwise.
	   */
	  function _checkLeft(targetOffset, tooltipLayerStyleRight, tooltipOffset, tooltipLayer) {
	    if (targetOffset.left + targetOffset.width - tooltipLayerStyleRight - tooltipOffset.width < 0) {
	      // off the left side of the window
	      tooltipLayer.style.left = (-targetOffset.left) + 'px';
	      return false;
	    }
	    tooltipLayer.style.right = tooltipLayerStyleRight + 'px';
	    return true;
	  }
	
	  /**
	   * Determines the position of the tooltip based on the position precedence and availability
	   * of screen space.
	   *
	   * @param {Object}    targetElement
	   * @param {Object}    tooltipLayer
	   * @param {String}    desiredTooltipPosition
	   * @return {String}   calculatedPosition
	   */
	  function _determineAutoPosition(targetElement, tooltipLayer, desiredTooltipPosition) {
	
	    // Take a clone of position precedence. These will be the available
	    var possiblePositions = this._options.positionPrecedence.slice();
	
	    var windowSize = _getWinSize();
	    var tooltipHeight = _getOffset(tooltipLayer).height + 10;
	    var tooltipWidth = _getOffset(tooltipLayer).width + 20;
	    var targetElementRect = targetElement.getBoundingClientRect();
	
	    // If we check all the possible areas, and there are no valid places for the tooltip, the element
	    // must take up most of the screen real estate. Show the tooltip floating in the middle of the screen.
	    var calculatedPosition = "floating";
	
	    /*
	    * auto determine position 
	    */
	
	    // Check for space below
	    if (targetElementRect.bottom + tooltipHeight + tooltipHeight > windowSize.height) {
	      _removeEntry(possiblePositions, "bottom");
	    }
	
	    // Check for space above
	    if (targetElementRect.top - tooltipHeight < 0) {
	      _removeEntry(possiblePositions, "top");
	    }
	
	    // Check for space to the right
	    if (targetElementRect.right + tooltipWidth > windowSize.width) {
	      _removeEntry(possiblePositions, "right");
	    }
	
	    // Check for space to the left
	    if (targetElementRect.left - tooltipWidth < 0) {
	      _removeEntry(possiblePositions, "left");
	    }
	
	    // @var {String}  ex: 'right-aligned'
	    var desiredAlignment = (function (pos) {
	      var hyphenIndex = pos.indexOf('-');
	      if (hyphenIndex !== -1) {
	        // has alignment
	        return pos.substr(hyphenIndex);
	      }
	      return '';
	    })(desiredTooltipPosition || '');
	
	    // strip alignment from position
	    if (desiredTooltipPosition) {
	      // ex: "bottom-right-aligned"
	      // should return 'bottom'
	      desiredTooltipPosition = desiredTooltipPosition.split('-')[0];
	    }
	
	    if (possiblePositions.length) {
	      if (desiredTooltipPosition !== "auto" &&
	          possiblePositions.indexOf(desiredTooltipPosition) > -1) {
	        // If the requested position is in the list, choose that
	        calculatedPosition = desiredTooltipPosition;
	      } else {
	        // Pick the first valid position, in order
	        calculatedPosition = possiblePositions[0];
	      }
	    }
	
	    // only top and bottom positions have optional alignments
	    if (['top', 'bottom'].indexOf(calculatedPosition) !== -1) {
	      calculatedPosition += _determineAutoAlignment(targetElementRect.left, tooltipWidth, windowSize, desiredAlignment);
	    }
	
	    return calculatedPosition;
	  }
	
	  /**
	  * auto-determine alignment
	  * @param {Integer}  offsetLeft
	  * @param {Integer}  tooltipWidth
	  * @param {Object}   windowSize
	  * @param {String}   desiredAlignment
	  * @return {String}  calculatedAlignment
	  */
	  function _determineAutoAlignment (offsetLeft, tooltipWidth, windowSize, desiredAlignment) {
	    var halfTooltipWidth = tooltipWidth / 2,
	      winWidth = Math.min(windowSize.width, window.screen.width),
	      possibleAlignments = ['-left-aligned', '-middle-aligned', '-right-aligned'],
	      calculatedAlignment = '';
	    
	    // valid left must be at least a tooltipWidth
	    // away from right side
	    if (winWidth - offsetLeft < tooltipWidth) {
	      _removeEntry(possibleAlignments, '-left-aligned');
	    }
	
	    // valid middle must be at least half 
	    // width away from both sides
	    if (offsetLeft < halfTooltipWidth || 
	      winWidth - offsetLeft < halfTooltipWidth) {
	      _removeEntry(possibleAlignments, '-middle-aligned');
	    }
	
	    // valid right must be at least a tooltipWidth
	    // width away from left side
	    if (offsetLeft < tooltipWidth) {
	      _removeEntry(possibleAlignments, '-right-aligned');
	    }
	
	    if (possibleAlignments.length) {
	      if (possibleAlignments.indexOf(desiredAlignment) !== -1) {
	        // the desired alignment is valid
	        calculatedAlignment = desiredAlignment;
	      } else {
	        // pick the first valid position, in order
	        calculatedAlignment = possibleAlignments[0];
	      }
	    } else {
	      // if screen width is too small 
	      // for ANY alignment, middle is 
	      // probably the best for visibility
	      calculatedAlignment = '-middle-aligned';
	    }
	
	    return calculatedAlignment;
	  }
	
	  /**
	   * Remove an entry from a string array if it's there, does nothing if it isn't there.
	   *
	   * @param {Array} stringArray
	   * @param {String} stringToRemove
	   */
	  function _removeEntry(stringArray, stringToRemove) {
	    if (stringArray.indexOf(stringToRemove) > -1) {
	      stringArray.splice(stringArray.indexOf(stringToRemove), 1);
	    }
	  }
	
	  /**
	   * Update the position of the helper layer on the screen
	   *
	   * @api private
	   * @method _setHelperLayerPosition
	   * @param {Object} helperLayer
	   */
	  function _setHelperLayerPosition(helperLayer) {
	    if (helperLayer) {
	      //prevent error when `this._currentStep` in undefined
	      if (!this._introItems[this._currentStep]) return;
	
	      var currentElement  = this._introItems[this._currentStep],
	          elementPosition = _getOffset(currentElement.element),
	          widthHeightPadding = this._options.helperElementPadding;
	
	      // If the target element is fixed, the tooltip should be fixed as well.
	      // Otherwise, remove a fixed class that may be left over from the previous
	      // step.
	      if (_isFixed(currentElement.element)) {
	        _addClass(helperLayer, 'introjs-fixedTooltip');
	      } else {
	        _removeClass(helperLayer, 'introjs-fixedTooltip');
	      }
	
	      if (currentElement.position === 'floating') {
	        widthHeightPadding = 0;
	      }
	
	      //set new position to helper layer
	      helperLayer.style.cssText = 'width: ' + (elementPosition.width  + widthHeightPadding)  + 'px; ' +
	                                        'height:' + (elementPosition.height + widthHeightPadding)  + 'px; ' +
	                                        'top:'    + (elementPosition.top    - widthHeightPadding / 2)   + 'px;' +
	                                        'left: '  + (elementPosition.left   - widthHeightPadding / 2)   + 'px;';
	
	    }
	  }
	
	  /**
	   * Add disableinteraction layer and adjust the size and position of the layer
	   *
	   * @api private
	   * @method _disableInteraction
	   */
	  function _disableInteraction() {
	    var disableInteractionLayer = document.querySelector('.introjs-disableInteraction');
	
	    if (disableInteractionLayer === null) {
	      disableInteractionLayer = document.createElement('div');
	      disableInteractionLayer.className = 'introjs-disableInteraction';
	      this._targetElement.appendChild(disableInteractionLayer);
	    }
	
	    _setHelperLayerPosition.call(this, disableInteractionLayer);
	  }
	
	  /**
	   * Setting anchors to behave like buttons
	   *
	   * @api private
	   * @method _setAnchorAsButton
	   */
	  function _setAnchorAsButton(anchor){
	    anchor.setAttribute('role', 'button');
	    anchor.tabIndex = 0;
	  }
	
	  /**
	   * Show an element on the page
	   *
	   * @api private
	   * @method _showElement
	   * @param {Object} targetElement
	   */
	  function _showElement(targetElement) {
	    if (typeof (this._introChangeCallback) !== 'undefined') {
	      this._introChangeCallback.call(this, targetElement.element);
	    }
	
	    var self = this,
	        oldHelperLayer = document.querySelector('.introjs-helperLayer'),
	        oldReferenceLayer = document.querySelector('.introjs-tooltipReferenceLayer'),
	        highlightClass = 'introjs-helperLayer',
	        nextTooltipButton,
	        prevTooltipButton,
	        skipTooltipButton,
	        scrollParent;
	
	    //check for a current step highlight class
	    if (typeof (targetElement.highlightClass) === 'string') {
	      highlightClass += (' ' + targetElement.highlightClass);
	    }
	    //check for options highlight class
	    if (typeof (this._options.highlightClass) === 'string') {
	      highlightClass += (' ' + this._options.highlightClass);
	    }
	
	    if (oldHelperLayer !== null) {
	      var oldHelperNumberLayer = oldReferenceLayer.querySelector('.introjs-helperNumberLayer'),
	          oldtooltipLayer      = oldReferenceLayer.querySelector('.introjs-tooltiptext'),
	          oldArrowLayer        = oldReferenceLayer.querySelector('.introjs-arrow'),
	          oldtooltipContainer  = oldReferenceLayer.querySelector('.introjs-tooltip');
	          
	      skipTooltipButton    = oldReferenceLayer.querySelector('.introjs-skipbutton');
	      prevTooltipButton    = oldReferenceLayer.querySelector('.introjs-prevbutton');
	      nextTooltipButton    = oldReferenceLayer.querySelector('.introjs-nextbutton');
	
	      //update or reset the helper highlight class
	      oldHelperLayer.className = highlightClass;
	      //hide the tooltip
	      oldtooltipContainer.style.opacity = 0;
	      oldtooltipContainer.style.display = "none";
	
	      if (oldHelperNumberLayer !== null) {
	        var lastIntroItem = this._introItems[(targetElement.step - 2 >= 0 ? targetElement.step - 2 : 0)];
	
	        if (lastIntroItem !== null && (this._direction === 'forward' && lastIntroItem.position === 'floating') || (this._direction === 'backward' && targetElement.position === 'floating')) {
	          oldHelperNumberLayer.style.opacity = 0;
	        }
	      }
	
	      // scroll to element
	      scrollParent = _getScrollParent( targetElement.element );
	
	      if (scrollParent !== document.body) {
	        // target is within a scrollable element
	        _scrollParentToElement(scrollParent, targetElement.element);
	      }
	
	      // set new position to helper layer
	      _setHelperLayerPosition.call(self, oldHelperLayer);
	      _setHelperLayerPosition.call(self, oldReferenceLayer);
	
	      //remove `introjs-fixParent` class from the elements
	      var fixParents = document.querySelectorAll('.introjs-fixParent');
	      _forEach(fixParents, function (parent) {
	        _removeClass(parent, /introjs-fixParent/g);
	      });
	      
	      //remove old classes if the element still exist
	      _removeShowElement();
	
	      //we should wait until the CSS3 transition is competed (it's 0.3 sec) to prevent incorrect `height` and `width` calculation
	      if (self._lastShowElementTimer) {
	        window.clearTimeout(self._lastShowElementTimer);
	      }
	
	      self._lastShowElementTimer = window.setTimeout(function() {
	        //set current step to the label
	        if (oldHelperNumberLayer !== null) {
	          oldHelperNumberLayer.innerHTML = targetElement.step;
	        }
	        //set current tooltip text
	        oldtooltipLayer.innerHTML = targetElement.intro;
	        //set the tooltip position
	        oldtooltipContainer.style.display = "block";
	        _placeTooltip.call(self, targetElement.element, oldtooltipContainer, oldArrowLayer, oldHelperNumberLayer);
	
	        //change active bullet
	        if (self._options.showBullets) {
	            oldReferenceLayer.querySelector('.introjs-bullets li > a.active').className = '';
	            oldReferenceLayer.querySelector('.introjs-bullets li > a[data-stepnumber="' + targetElement.step + '"]').className = 'active';
	        }
	        oldReferenceLayer.querySelector('.introjs-progress .introjs-progressbar').style.cssText = 'width:' + _getProgress.call(self) + '%;';
	        oldReferenceLayer.querySelector('.introjs-progress .introjs-progressbar').setAttribute('aria-valuenow', _getProgress.call(self));
	
	        //show the tooltip
	        oldtooltipContainer.style.opacity = 1;
	        if (oldHelperNumberLayer) oldHelperNumberLayer.style.opacity = 1;
	
	        //reset button focus
	        if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null && /introjs-donebutton/gi.test(skipTooltipButton.className)) {
	          // skip button is now "done" button
	          skipTooltipButton.focus();
	        } else if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	          //still in the tour, focus on next
	          nextTooltipButton.focus();
	        }
	
	        // change the scroll of the window, if needed
	        _scrollTo.call(self, targetElement.scrollTo, targetElement, oldtooltipLayer);
	      }, 350);
	
	      // end of old element if-else condition
	    } else {
	      var helperLayer       = document.createElement('div'),
	          referenceLayer    = document.createElement('div'),
	          arrowLayer        = document.createElement('div'),
	          tooltipLayer      = document.createElement('div'),
	          tooltipTextLayer  = document.createElement('div'),
	          bulletsLayer      = document.createElement('div'),
	          progressLayer     = document.createElement('div'),
	          buttonsLayer      = document.createElement('div');
	
	      helperLayer.className = highlightClass;
	      referenceLayer.className = 'introjs-tooltipReferenceLayer';
	
	      // scroll to element
	      scrollParent = _getScrollParent( targetElement.element );
	
	      if (scrollParent !== document.body) {
	        // target is within a scrollable element
	        _scrollParentToElement(scrollParent, targetElement.element);
	      }
	
	      //set new position to helper layer
	      _setHelperLayerPosition.call(self, helperLayer);
	      _setHelperLayerPosition.call(self, referenceLayer);
	
	      //add helper layer to target element
	      this._targetElement.appendChild(helperLayer);
	      this._targetElement.appendChild(referenceLayer);
	
	      arrowLayer.className = 'introjs-arrow';
	
	      tooltipTextLayer.className = 'introjs-tooltiptext';
	      tooltipTextLayer.innerHTML = targetElement.intro;
	
	      bulletsLayer.className = 'introjs-bullets';
	
	      if (this._options.showBullets === false) {
	        bulletsLayer.style.display = 'none';
	      }
	
	      var ulContainer = document.createElement('ul');
	      ulContainer.setAttribute('role', 'tablist');
	
	      var anchorClick = function () {
	          self.goToStep(this.getAttribute('data-stepnumber'));
	      };
	
	      _forEach(this._introItems, function (item, i) {
	        var innerLi    = document.createElement('li');
	        var anchorLink = document.createElement('a');
	        
	        innerLi.setAttribute('role', 'presentation');
	        anchorLink.setAttribute('role', 'tab');
	
	        anchorLink.onclick = anchorClick;
	
	        if (i === (targetElement.step-1)) {
	          anchorLink.className = 'active';
	        } 
	
	        _setAnchorAsButton(anchorLink);
	        anchorLink.innerHTML = "&nbsp;";
	        anchorLink.setAttribute('data-stepnumber', item.step);
	
	        innerLi.appendChild(anchorLink);
	        ulContainer.appendChild(innerLi);
	      });
	
	      bulletsLayer.appendChild(ulContainer);
	
	      progressLayer.className = 'introjs-progress';
	
	      if (this._options.showProgress === false) {
	        progressLayer.style.display = 'none';
	      }
	      var progressBar = document.createElement('div');
	      progressBar.className = 'introjs-progressbar';
	      progressBar.setAttribute('role', 'progress');
	      progressBar.setAttribute('aria-valuemin', 0);
	      progressBar.setAttribute('aria-valuemax', 100);
	      progressBar.setAttribute('aria-valuenow', _getProgress.call(this));
	      progressBar.style.cssText = 'width:' + _getProgress.call(this) + '%;';
	
	      progressLayer.appendChild(progressBar);
	
	      buttonsLayer.className = 'introjs-tooltipbuttons';
	      if (this._options.showButtons === false) {
	        buttonsLayer.style.display = 'none';
	      }
	
	      tooltipLayer.className = 'introjs-tooltip';
	      tooltipLayer.appendChild(tooltipTextLayer);
	      tooltipLayer.appendChild(bulletsLayer);
	      tooltipLayer.appendChild(progressLayer);
	
	      //add helper layer number
	      var helperNumberLayer = document.createElement('span');
	      if (this._options.showStepNumbers === true) {
	        helperNumberLayer.className = 'introjs-helperNumberLayer';
	        helperNumberLayer.innerHTML = targetElement.step;
	        referenceLayer.appendChild(helperNumberLayer);
	      }
	
	      tooltipLayer.appendChild(arrowLayer);
	      referenceLayer.appendChild(tooltipLayer);
	
	      //next button
	      nextTooltipButton = document.createElement('a');
	
	      nextTooltipButton.onclick = function() {
	        if (self._introItems.length - 1 !== self._currentStep) {
	          _nextStep.call(self);
	        }
	      };
	
	      _setAnchorAsButton(nextTooltipButton);
	      nextTooltipButton.innerHTML = this._options.nextLabel;
	
	      //previous button
	      prevTooltipButton = document.createElement('a');
	
	      prevTooltipButton.onclick = function() {
	        if (self._currentStep !== 0) {
	          _previousStep.call(self);
	        }
	      };
	
	      _setAnchorAsButton(prevTooltipButton);
	      prevTooltipButton.innerHTML = this._options.prevLabel;
	
	      //skip button
	      skipTooltipButton = document.createElement('a');
	      skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton ';
	      _setAnchorAsButton(skipTooltipButton);
	      skipTooltipButton.innerHTML = this._options.skipLabel;
	
	      skipTooltipButton.onclick = function() {
	        if (self._introItems.length - 1 === self._currentStep && typeof (self._introCompleteCallback) === 'function') {
	          self._introCompleteCallback.call(self);
	        }
	
	        if (self._introItems.length - 1 !== self._currentStep && typeof (self._introExitCallback) === 'function') {
	          self._introExitCallback.call(self);
	        }
	
	        if (typeof(self._introSkipCallback) === 'function') {
	          self._introSkipCallback.call(self);
	        }
	
	        _exitIntro.call(self, self._targetElement);
	      };
	
	      buttonsLayer.appendChild(skipTooltipButton);
	
	      //in order to prevent displaying next/previous button always
	      if (this._introItems.length > 1) {
	        buttonsLayer.appendChild(prevTooltipButton);
	        buttonsLayer.appendChild(nextTooltipButton);
	      }
	
	      tooltipLayer.appendChild(buttonsLayer);
	
	      //set proper position
	      _placeTooltip.call(self, targetElement.element, tooltipLayer, arrowLayer, helperNumberLayer);
	
	      // change the scroll of the window, if needed
	      _scrollTo.call(this, targetElement.scrollTo, targetElement, tooltipLayer);
	
	      //end of new element if-else condition
	    }
	
	    // removing previous disable interaction layer
	    var disableInteractionLayer = self._targetElement.querySelector('.introjs-disableInteraction');
	    if (disableInteractionLayer) {
	      disableInteractionLayer.parentNode.removeChild(disableInteractionLayer);
	    }
	
	    //disable interaction
	    if (targetElement.disableInteraction) {
	      _disableInteraction.call(self);
	    }
	
	    // when it's the first step of tour
	    if (this._currentStep === 0 && this._introItems.length > 1) {
	      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
	        skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton';
	      }
	      if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	        nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton';
	      }
	
	      if (this._options.hidePrev === true) {
	        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
	          prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton introjs-hidden';
	        }
	        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	          _addClass(nextTooltipButton, 'introjs-fullbutton');
	        }
	      } else {
	        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
	          prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton introjs-disabled';
	        }
	      }
	
	      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
	        skipTooltipButton.innerHTML = this._options.skipLabel;
	      }
	    } else if (this._introItems.length - 1 === this._currentStep || this._introItems.length === 1) {
	      // last step of tour
	      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
	        skipTooltipButton.innerHTML = this._options.doneLabel;
	        // adding donebutton class in addition to skipbutton
	        _addClass(skipTooltipButton, 'introjs-donebutton');
	      }
	      if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
	        prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton';
	      }
	
	      if (this._options.hideNext === true) {
	        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	          nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton introjs-hidden';
	        }
	        if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
	          _addClass(prevTooltipButton, 'introjs-fullbutton');
	        }
	      } else {
	        if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	          nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton introjs-disabled';
	        }
	      }
	    } else {
	      // steps between start and end
	      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
	        skipTooltipButton.className = this._options.buttonClass + ' introjs-skipbutton';
	      }
	      if (typeof prevTooltipButton !== "undefined" && prevTooltipButton !== null) {
	        prevTooltipButton.className = this._options.buttonClass + ' introjs-prevbutton';
	      }
	      if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	        nextTooltipButton.className = this._options.buttonClass + ' introjs-nextbutton';
	      }
	      if (typeof skipTooltipButton !== "undefined" && skipTooltipButton !== null) {
	        skipTooltipButton.innerHTML = this._options.skipLabel;
	      }
	    }
	
	    prevTooltipButton.setAttribute('role', 'button');
	    nextTooltipButton.setAttribute('role', 'button');
	    skipTooltipButton.setAttribute('role', 'button');
	
	    //Set focus on "next" button, so that hitting Enter always moves you onto the next step
	    if (typeof nextTooltipButton !== "undefined" && nextTooltipButton !== null) {
	      nextTooltipButton.focus();
	    }
	
	    _setShowElement(targetElement);
	
	    if (typeof (this._introAfterChangeCallback) !== 'undefined') {
	      this._introAfterChangeCallback.call(this, targetElement.element);
	    }
	  }
	
	  /**
	   * To change the scroll of `window` after highlighting an element
	   *
	   * @api private
	   * @method _scrollTo
	   * @param {String} scrollTo
	   * @param {Object} targetElement
	   * @param {Object} tooltipLayer
	   */
	  function _scrollTo(scrollTo, targetElement, tooltipLayer) {
	    if (scrollTo === 'off') return;  
	    var rect;
	
	    if (!this._options.scrollToElement) return;
	
	    if (scrollTo === 'tooltip') {
	      rect = tooltipLayer.getBoundingClientRect();
	    } else {
	      rect = targetElement.element.getBoundingClientRect();
	    }
	
	    if (!_elementInViewport(targetElement.element)) {
	      var winHeight = _getWinSize().height;
	      var top = rect.bottom - (rect.bottom - rect.top);
	
	      // TODO (afshinm): do we need scroll padding now?
	      // I have changed the scroll option and now it scrolls the window to
	      // the center of the target element or tooltip.
	
	      if (top < 0 || targetElement.element.clientHeight > winHeight) {
	        window.scrollBy(0, rect.top - ((winHeight / 2) -  (rect.height / 2)) - this._options.scrollPadding); // 30px padding from edge to look nice
	
	      //Scroll down
	      } else {
	        window.scrollBy(0, rect.top - ((winHeight / 2) -  (rect.height / 2)) + this._options.scrollPadding); // 30px padding from edge to look nice
	      }
	    }
	  }
	
	  /**
	   * To remove all show element(s)
	   *
	   * @api private
	   * @method _removeShowElement
	   */
	  function _removeShowElement() {
	    var elms = document.querySelectorAll('.introjs-showElement');
	
	    _forEach(elms, function (elm) {
	      _removeClass(elm, /introjs-[a-zA-Z]+/g);
	    });
	  }
	
	  /**
	   * To set the show element
	   * This function set a relative (in most cases) position and changes the z-index
	   *
	   * @api private
	   * @method _setShowElement
	   * @param {Object} targetElement
	   */
	  function _setShowElement(targetElement) {
	    var parentElm;
	    // we need to add this show element class to the parent of SVG elements
	    // because the SVG elements can't have independent z-index
	    if (targetElement.element instanceof SVGElement) {
	      parentElm = targetElement.element.parentNode;
	
	      while (targetElement.element.parentNode !== null) {
	        if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;
	
	        if (parentElm.tagName.toLowerCase() === 'svg') {
	          _addClass(parentElm, 'introjs-showElement introjs-relativePosition');
	        }
	
	        parentElm = parentElm.parentNode;
	      }
	    }
	
	    _addClass(targetElement.element, 'introjs-showElement');
	
	    var currentElementPosition = _getPropValue(targetElement.element, 'position');
	    if (currentElementPosition !== 'absolute' &&
	        currentElementPosition !== 'relative' &&
	        currentElementPosition !== 'fixed') {
	      //change to new intro item
	      _addClass(targetElement.element, 'introjs-relativePosition');
	    }
	
	    parentElm = targetElement.element.parentNode;
	    while (parentElm !== null) {
	      if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') break;
	
	      //fix The Stacking Context problem.
	      //More detail: https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Understanding_z_index/The_stacking_context
	      var zIndex = _getPropValue(parentElm, 'z-index');
	      var opacity = parseFloat(_getPropValue(parentElm, 'opacity'));
	      var transform = _getPropValue(parentElm, 'transform') || _getPropValue(parentElm, '-webkit-transform') || _getPropValue(parentElm, '-moz-transform') || _getPropValue(parentElm, '-ms-transform') || _getPropValue(parentElm, '-o-transform');
	      if (/[0-9]+/.test(zIndex) || opacity < 1 || (transform !== 'none' && transform !== undefined)) {
	        _addClass(parentElm, 'introjs-fixParent');
	      }
	
	      parentElm = parentElm.parentNode;
	    }
	  }
	
	  /**
	  * Iterates arrays
	  *
	  * @param {Array} arr
	  * @param {Function} forEachFnc
	  * @param {Function} completeFnc
	  * @return {Null}
	  */
	  function _forEach(arr, forEachFnc, completeFnc) {
	    // in case arr is an empty query selector node list
	    if (arr) {
	      for (var i = 0, len = arr.length; i < len; i++) {
	        forEachFnc(arr[i], i);
	      }
	    }
	
	    if (typeof(completeFnc) === 'function') {
	      completeFnc();
	    }
	  }
	
	  /**
	  * Mark any object with an incrementing number
	  * used for keeping track of objects
	  *
	  * @param Object obj   Any object or DOM Element
	  * @param String key
	  * @return Object
	  */
	  var _stamp = (function () {
	    var keys = {};
	    return function stamp (obj, key) {
	      
	      // get group key
	      key = key || 'introjs-stamp';
	
	      // each group increments from 0
	      keys[key] = keys[key] || 0;
	
	      // stamp only once per object
	      if (obj[key] === undefined) {
	        // increment key for each new object
	        obj[key] = keys[key]++;
	      }
	
	      return obj[key];
	    };
	  })();
	
	  /**
	  * DOMEvent Handles all DOM events
	  *
	  * methods:
	  *
	  * on - add event handler
	  * off - remove event
	  */
	  var DOMEvent = (function () {
	    function DOMEvent () {
	      var events_key = 'introjs_event';
	      
	      /**
	      * Gets a unique ID for an event listener
	      *
	      * @param Object obj
	      * @param String type        event type
	      * @param Function listener
	      * @param Object context
	      * @return String
	      */
	      this._id = function (obj, type, listener, context) {
	        return type + _stamp(listener) + (context ? '_' + _stamp(context) : '');
	      };
	
	      /**
	      * Adds event listener
	      *
	      * @param Object obj
	      * @param String type        event type
	      * @param Function listener
	      * @param Object context
	      * @param Boolean useCapture
	      * @return null
	      */
	      this.on = function (obj, type, listener, context, useCapture) {
	        var id = this._id.apply(this, arguments),
	            handler = function (e) {
	              return listener.call(context || obj, e || window.event);
	            };
	
	        if ('addEventListener' in obj) {
	          obj.addEventListener(type, handler, useCapture);
	        } else if ('attachEvent' in obj) {
	          obj.attachEvent('on' + type, handler);
	        }
	
	        obj[events_key] = obj[events_key] || {};
	        obj[events_key][id] = handler;
	      };
	
	      /**
	      * Removes event listener
	      *
	      * @param Object obj
	      * @param String type        event type
	      * @param Function listener
	      * @param Object context
	      * @param Boolean useCapture
	      * @return null
	      */
	      this.off = function (obj, type, listener, context, useCapture) {
	        var id = this._id.apply(this, arguments),
	            handler = obj[events_key] && obj[events_key][id];
	
	        if (!handler) {
	          return;
	        }
	
	        if ('removeEventListener' in obj) {
	          obj.removeEventListener(type, handler, useCapture);
	        } else if ('detachEvent' in obj) {
	          obj.detachEvent('on' + type, handler);
	        }
	
	        obj[events_key][id] = null;
	      };
	    }
	
	    return new DOMEvent();
	  })();
	
	  /**
	   * Append a class to an element
	   *
	   * @api private
	   * @method _addClass
	   * @param {Object} element
	   * @param {String} className
	   * @returns null
	   */
	  function _addClass(element, className) {
	    if (element instanceof SVGElement) {
	      // svg
	      var pre = element.getAttribute('class') || '';
	
	      element.setAttribute('class', pre + ' ' + className);
	    } else {
	      if (element.classList !== undefined) {
	        // check for modern classList property
	        var classes = className.split(' ');
	        _forEach(classes, function (cls) {
	          element.classList.add( cls );
	        });
	      } else if (!element.className.match( className )) {
	        // check if element doesn't already have className
	        element.className += ' ' + className;
	      }
	    }
	  }
	
	  /**
	   * Remove a class from an element
	   *
	   * @api private
	   * @method _removeClass
	   * @param {Object} element
	   * @param {RegExp|String} classNameRegex can be regex or string
	   * @returns null
	   */
	  function _removeClass(element, classNameRegex) {
	    if (element instanceof SVGElement) {
	      var pre = element.getAttribute('class') || '';
	
	      element.setAttribute('class', pre.replace(classNameRegex, '').replace(/^\s+|\s+$/g, ''));
	    } else {
	      element.className = element.className.replace(classNameRegex, '').replace(/^\s+|\s+$/g, '');
	    }
	  }
	
	  /**
	   * Get an element CSS property on the page
	   * Thanks to JavaScript Kit: http://www.javascriptkit.com/dhtmltutors/dhtmlcascade4.shtml
	   *
	   * @api private
	   * @method _getPropValue
	   * @param {Object} element
	   * @param {String} propName
	   * @returns Element's property value
	   */
	  function _getPropValue (element, propName) {
	    var propValue = '';
	    if (element.currentStyle) { //IE
	      propValue = element.currentStyle[propName];
	    } else if (document.defaultView && document.defaultView.getComputedStyle) { //Others
	      propValue = document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
	    }
	
	    //Prevent exception in IE
	    if (propValue && propValue.toLowerCase) {
	      return propValue.toLowerCase();
	    } else {
	      return propValue;
	    }
	  }
	
	  /**
	   * Checks to see if target element (or parents) position is fixed or not
	   *
	   * @api private
	   * @method _isFixed
	   * @param {Object} element
	   * @returns Boolean
	   */
	  function _isFixed (element) {
	    var p = element.parentNode;
	
	    if (!p || p.nodeName === 'HTML') {
	      return false;
	    }
	
	    if (_getPropValue(element, 'position') === 'fixed') {
	      return true;
	    }
	
	    return _isFixed(p);
	  }
	
	  /**
	   * Provides a cross-browser way to get the screen dimensions
	   * via: http://stackoverflow.com/questions/5864467/internet-explorer-innerheight
	   *
	   * @api private
	   * @method _getWinSize
	   * @returns {Object} width and height attributes
	   */
	  function _getWinSize() {
	    if (window.innerWidth !== undefined) {
	      return { width: window.innerWidth, height: window.innerHeight };
	    } else {
	      var D = document.documentElement;
	      return { width: D.clientWidth, height: D.clientHeight };
	    }
	  }
	
	  /**
	   * Check to see if the element is in the viewport or not
	   * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
	   *
	   * @api private
	   * @method _elementInViewport
	   * @param {Object} el
	   */
	  function _elementInViewport(el) {
	    var rect = el.getBoundingClientRect();
	
	    return (
	      rect.top >= 0 &&
	      rect.left >= 0 &&
	      (rect.bottom+80) <= window.innerHeight && // add 80 to get the text right
	      rect.right <= window.innerWidth
	    );
	  }
	
	  /**
	   * Add overlay layer to the page
	   *
	   * @api private
	   * @method _addOverlayLayer
	   * @param {Object} targetElm
	   */
	  function _addOverlayLayer(targetElm) {
	    var overlayLayer = document.createElement('div'),
	        styleText = '',
	        self = this;
	
	    //set css class name
	    overlayLayer.className = 'introjs-overlay';
	
	    //check if the target element is body, we should calculate the size of overlay layer in a better way
	    if (!targetElm.tagName || targetElm.tagName.toLowerCase() === 'body') {
	      styleText += 'top: 0;bottom: 0; left: 0;right: 0;position: fixed;';
	      overlayLayer.style.cssText = styleText;
	    } else {
	      //set overlay layer position
	      var elementPosition = _getOffset(targetElm);
	      if (elementPosition) {
	        styleText += 'width: ' + elementPosition.width + 'px; height:' + elementPosition.height + 'px; top:' + elementPosition.top + 'px;left: ' + elementPosition.left + 'px;';
	        overlayLayer.style.cssText = styleText;
	      }
	    }
	
	    targetElm.appendChild(overlayLayer);
	
	    overlayLayer.onclick = function() {
	      if (self._options.exitOnOverlayClick === true) {
	        _exitIntro.call(self, targetElm);
	      }
	    };
	
	    window.setTimeout(function() {
	      styleText += 'opacity: ' + self._options.overlayOpacity.toString() + ';';
	      overlayLayer.style.cssText = styleText;
	    }, 10);
	
	    return true;
	  }
	
	  /**
	   * Removes open hint (tooltip hint)
	   *
	   * @api private
	   * @method _removeHintTooltip
	   */
	  function _removeHintTooltip() {
	    var tooltip = document.querySelector('.introjs-hintReference');
	
	    if (tooltip) {
	      var step = tooltip.getAttribute('data-step');
	      tooltip.parentNode.removeChild(tooltip);
	      return step;
	    }
	  }
	
	  /**
	   * Start parsing hint items
	   *
	   * @api private
	   * @param {Object} targetElm
	   * @method _startHint
	   */
	  function _populateHints(targetElm) {
	
	    this._introItems = [];
	
	    if (this._options.hints) {
	      _forEach(this._options.hints, function (hint) {
	        var currentItem = _cloneObject(hint);
	
	        if (typeof(currentItem.element) === 'string') {
	          //grab the element with given selector from the page
	          currentItem.element = document.querySelector(currentItem.element);
	        }
	
	        currentItem.hintPosition = currentItem.hintPosition || this._options.hintPosition;
	        currentItem.hintAnimation = currentItem.hintAnimation || this._options.hintAnimation;
	
	        if (currentItem.element !== null) {
	          this._introItems.push(currentItem);
	        }
	      }.bind(this));
	    } else {
	      var hints = targetElm.querySelectorAll('*[data-hint]');
	
	      if (!hints || !hints.length) {
	        return false;
	      }
	
	      //first add intro items with data-step
	      _forEach(hints, function (currentElement) {
	        // hint animation
	        var hintAnimation = currentElement.getAttribute('data-hintanimation');
	
	        if (hintAnimation) {
	          hintAnimation = (hintAnimation === 'true');
	        } else {
	          hintAnimation = this._options.hintAnimation;
	        }
	
	        this._introItems.push({
	          element: currentElement,
	          hint: currentElement.getAttribute('data-hint'),
	          hintPosition: currentElement.getAttribute('data-hintposition') || this._options.hintPosition,
	          hintAnimation: hintAnimation,
	          tooltipClass: currentElement.getAttribute('data-tooltipclass'),
	          position: currentElement.getAttribute('data-position') || this._options.tooltipPosition
	        });
	      }.bind(this));
	    }
	
	    _addHints.call(this);
	
	    /* 
	    todo:
	    these events should be removed at some point 
	    */
	    DOMEvent.on(document, 'click', _removeHintTooltip, this, false);
	    DOMEvent.on(window, 'resize', _reAlignHints, this, true);
	  }
	
	  /**
	   * Re-aligns all hint elements
	   *
	   * @api private
	   * @method _reAlignHints
	   */
	  function _reAlignHints() {
	    _forEach(this._introItems, function (item) {
	      if (typeof(item.targetElement) === 'undefined') {
	        return;
	      }
	
	      _alignHintPosition.call(this, item.hintPosition, item.element, item.targetElement);
	    }.bind(this));
	  }
	
	  /**
	  * Get a queryselector within the hint wrapper
	  *
	  * @param {String} selector
	  * @return {NodeList|Array}
	  */
	  function _hintQuerySelectorAll(selector) {
	    var hintsWrapper = document.querySelector('.introjs-hints');
	    return (hintsWrapper) ? hintsWrapper.querySelectorAll(selector) : [];
	  }
	
	  /**
	   * Hide a hint
	   *
	   * @api private
	   * @method _hideHint
	   */
	  function _hideHint(stepId) {
	    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];
	    
	    _removeHintTooltip.call(this);
	
	    if (hint) {
	      _addClass(hint, 'introjs-hidehint');
	    }
	
	    // call the callback function (if any)
	    if (typeof (this._hintCloseCallback) !== 'undefined') {
	      this._hintCloseCallback.call(this, stepId);
	    }
	  }
	
	  /**
	   * Hide all hints
	   *
	   * @api private
	   * @method _hideHints
	   */
	  function _hideHints() {
	    var hints = _hintQuerySelectorAll('.introjs-hint');
	
	    _forEach(hints, function (hint) {
	      _hideHint.call(this, hint.getAttribute('data-step'));
	    }.bind(this));
	  }
	
	  /**
	   * Show all hints
	   *
	   * @api private
	   * @method _showHints
	   */
	  function _showHints() {
	    var hints = _hintQuerySelectorAll('.introjs-hint');
	
	    if (hints && hints.length) {
	      _forEach(hints, function (hint) {
	        _showHint.call(this, hint.getAttribute('data-step'));
	      }.bind(this));
	    } else {
	      _populateHints.call(this, this._targetElement);
	    }
	  }
	
	  /**
	   * Show a hint
	   *
	   * @api private
	   * @method _showHint
	   */
	  function _showHint(stepId) {
	    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];
	
	    if (hint) {
	      _removeClass(hint, /introjs-hidehint/g);
	    }
	  }
	
	  /**
	   * Removes all hint elements on the page
	   * Useful when you want to destroy the elements and add them again (e.g. a modal or popup)
	   *
	   * @api private
	   * @method _removeHints
	   */
	  function _removeHints() {
	    var hints = _hintQuerySelectorAll('.introjs-hint');
	
	    _forEach(hints, function (hint) {
	      _removeHint.call(this, hint.getAttribute('data-step'));
	    }.bind(this));
	  }
	
	  /**
	   * Remove one single hint element from the page
	   * Useful when you want to destroy the element and add them again (e.g. a modal or popup)
	   * Use removeHints if you want to remove all elements.
	   *
	   * @api private
	   * @method _removeHint
	   */
	  function _removeHint(stepId) {
	    var hint = _hintQuerySelectorAll('.introjs-hint[data-step="' + stepId + '"]')[0];
	
	    if (hint) {
	      hint.parentNode.removeChild(hint);
	    }
	  }
	
	  /**
	   * Add all available hints to the page
	   *
	   * @api private
	   * @method _addHints
	   */
	  function _addHints() {
	    var self = this;
	
	    var hintsWrapper = document.querySelector('.introjs-hints');
	
	    if (hintsWrapper === null) {
	      hintsWrapper = document.createElement('div');
	      hintsWrapper.className = 'introjs-hints';
	    }
	
	    /**
	    * Returns an event handler unique to the hint iteration
	    * 
	    * @param {Integer} i
	    * @return {Function}
	    */
	    var getHintClick = function (i) {
	      return function(e) {
	        var evt = e ? e : window.event;
	        
	        if (evt.stopPropagation) {
	          evt.stopPropagation();
	        }
	
	        if (evt.cancelBubble !== null) {
	          evt.cancelBubble = true;
	        }
	
	        _showHintDialog.call(self, i);
	      };
	    };
	
	    _forEach(this._introItems, function(item, i) {
	      // avoid append a hint twice
	      if (document.querySelector('.introjs-hint[data-step="' + i + '"]')) {
	        return;
	      }
	
	      var hint = document.createElement('a');
	      _setAnchorAsButton(hint);
	
	      hint.onclick = getHintClick(i);
	
	      hint.className = 'introjs-hint';
	
	      if (!item.hintAnimation) {
	        _addClass(hint, 'introjs-hint-no-anim');
	      }
	
	      // hint's position should be fixed if the target element's position is fixed
	      if (_isFixed(item.element)) {
	        _addClass(hint, 'introjs-fixedhint');
	      }
	
	      var hintDot = document.createElement('div');
	      hintDot.className = 'introjs-hint-dot';
	      var hintPulse = document.createElement('div');
	      hintPulse.className = 'introjs-hint-pulse';
	
	      hint.appendChild(hintDot);
	      hint.appendChild(hintPulse);
	      hint.setAttribute('data-step', i);
	
	      // we swap the hint element with target element
	      // because _setHelperLayerPosition uses `element` property
	      item.targetElement = item.element;
	      item.element = hint;
	
	      // align the hint position
	      _alignHintPosition.call(this, item.hintPosition, hint, item.targetElement);
	
	      hintsWrapper.appendChild(hint);
	    }.bind(this));
	
	    // adding the hints wrapper
	    document.body.appendChild(hintsWrapper);
	
	    // call the callback function (if any)
	    if (typeof (this._hintsAddedCallback) !== 'undefined') {
	      this._hintsAddedCallback.call(this);
	    }
	  }
	
	  /**
	   * Aligns hint position
	   *
	   * @api private
	   * @method _alignHintPosition
	   * @param {String} position
	   * @param {Object} hint
	   * @param {Object} element
	   */
	  function _alignHintPosition(position, hint, element) {
	    // get/calculate offset of target element
	    var offset = _getOffset.call(this, element);
	    var iconWidth = 20;
	    var iconHeight = 20;
	
	    // align the hint element
	    switch (position) {
	      default:
	      case 'top-left':
	        hint.style.left = offset.left + 'px';
	        hint.style.top = offset.top + 'px';
	        break;
	      case 'top-right':
	        hint.style.left = (offset.left + offset.width - iconWidth) + 'px';
	        hint.style.top = offset.top + 'px';
	        break;
	      case 'bottom-left':
	        hint.style.left = offset.left + 'px';
	        hint.style.top = (offset.top + offset.height - iconHeight) + 'px';
	        break;
	      case 'bottom-right':
	        hint.style.left = (offset.left + offset.width - iconWidth) + 'px';
	        hint.style.top = (offset.top + offset.height - iconHeight) + 'px';
	        break;
	      case 'middle-left':
	        hint.style.left = offset.left + 'px';
	        hint.style.top = (offset.top + (offset.height - iconHeight) / 2) + 'px';
	        break;
	      case 'middle-right':
	        hint.style.left = (offset.left + offset.width - iconWidth) + 'px';
	        hint.style.top = (offset.top + (offset.height - iconHeight) / 2) + 'px';
	        break;
	      case 'middle-middle':
	        hint.style.left = (offset.left + (offset.width - iconWidth) / 2) + 'px';
	        hint.style.top = (offset.top + (offset.height - iconHeight) / 2) + 'px';
	        break;
	      case 'bottom-middle':
	        hint.style.left = (offset.left + (offset.width - iconWidth) / 2) + 'px';
	        hint.style.top = (offset.top + offset.height - iconHeight) + 'px';
	        break;
	      case 'top-middle':
	        hint.style.left = (offset.left + (offset.width - iconWidth) / 2) + 'px';
	        hint.style.top = offset.top + 'px';
	        break;
	    }
	  }
	
	  /**
	   * Triggers when user clicks on the hint element
	   *
	   * @api private
	   * @method _showHintDialog
	   * @param {Number} stepId
	   */
	  function _showHintDialog(stepId) {
	    var hintElement = document.querySelector('.introjs-hint[data-step="' + stepId + '"]');
	    var item = this._introItems[stepId];
	
	    // call the callback function (if any)
	    if (typeof (this._hintClickCallback) !== 'undefined') {
	      this._hintClickCallback.call(this, hintElement, item, stepId);
	    }
	
	    // remove all open tooltips
	    var removedStep = _removeHintTooltip.call(this);
	
	    // to toggle the tooltip
	    if (parseInt(removedStep, 10) === stepId) {
	      return;
	    }
	
	    var tooltipLayer = document.createElement('div');
	    var tooltipTextLayer = document.createElement('div');
	    var arrowLayer = document.createElement('div');
	    var referenceLayer = document.createElement('div');
	
	    tooltipLayer.className = 'introjs-tooltip';
	
	    tooltipLayer.onclick = function (e) {
	      //IE9 & Other Browsers
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      }
	      //IE8 and Lower
	      else {
	        e.cancelBubble = true;
	      }
	    };
	
	    tooltipTextLayer.className = 'introjs-tooltiptext';
	
	    var tooltipWrapper = document.createElement('p');
	    tooltipWrapper.innerHTML = item.hint;
	
	    var closeButton = document.createElement('a');
	    closeButton.className = this._options.buttonClass;
	    closeButton.setAttribute('role', 'button');
	    closeButton.innerHTML = this._options.hintButtonLabel;
	    closeButton.onclick = _hideHint.bind(this, stepId);
	
	    tooltipTextLayer.appendChild(tooltipWrapper);
	    tooltipTextLayer.appendChild(closeButton);
	
	    arrowLayer.className = 'introjs-arrow';
	    tooltipLayer.appendChild(arrowLayer);
	
	    tooltipLayer.appendChild(tooltipTextLayer);
	
	    // set current step for _placeTooltip function
	    this._currentStep = hintElement.getAttribute('data-step');
	
	    // align reference layer position
	    referenceLayer.className = 'introjs-tooltipReferenceLayer introjs-hintReference';
	    referenceLayer.setAttribute('data-step', hintElement.getAttribute('data-step'));
	    _setHelperLayerPosition.call(this, referenceLayer);
	
	    referenceLayer.appendChild(tooltipLayer);
	    document.body.appendChild(referenceLayer);
	
	    //set proper position
	    _placeTooltip.call(this, hintElement, tooltipLayer, arrowLayer, null, true);
	  }
	
	  /**
	   * Get an element position on the page
	   * Thanks to `meouw`: http://stackoverflow.com/a/442474/375966
	   *
	   * @api private
	   * @method _getOffset
	   * @param {Object} element
	   * @returns Element's position info
	   */
	  function _getOffset(element) {
	    var body = document.body;
	    var docEl = document.documentElement;
	    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
	    var x = element.getBoundingClientRect();
	    return {
	      top: x.top + scrollTop,
	      width: x.width,
	      height: x.height,
	      left: x.left + scrollLeft
	    };
	  }
	
	  /**
	  * Find the nearest scrollable parent
	  * copied from https://stackoverflow.com/questions/35939886/find-first-scrollable-parent
	  *
	  * @param Element element
	  * @return Element
	  */
	  function _getScrollParent(element) {
	    var style = window.getComputedStyle(element);
	    var excludeStaticParent = (style.position === "absolute");
	    var overflowRegex = /(auto|scroll)/;
	
	    if (style.position === "fixed") return document.body;
	    
	    for (var parent = element; (parent = parent.parentElement);) {
	      style = window.getComputedStyle(parent);
	      if (excludeStaticParent && style.position === "static") {
	        continue;
	      }
	      if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
	    }
	
	    return document.body;
	  }
	
	  /**
	  * scroll a scrollable element to a child element
	  *
	  * @param Element parent
	  * @param Element element
	  * @return Null
	  */
	  function _scrollParentToElement (parent, element) {
	    parent.scrollTop = element.offsetTop - parent.offsetTop;
	  }
	
	  /**
	   * Gets the current progress percentage
	   *
	   * @api private
	   * @method _getProgress
	   * @returns current progress percentage
	   */
	  function _getProgress() {
	    // Steps are 0 indexed
	    var currentStep = parseInt((this._currentStep + 1), 10);
	    return ((currentStep / this._introItems.length) * 100);
	  }
	
	  /**
	   * Overwrites obj1's values with obj2's and adds obj2's if non existent in obj1
	   * via: http://stackoverflow.com/questions/171251/how-can-i-merge-properties-of-two-javascript-objects-dynamically
	   *
	   * @param obj1
	   * @param obj2
	   * @returns obj3 a new object based on obj1 and obj2
	   */
	  function _mergeOptions(obj1,obj2) {
	    var obj3 = {},
	      attrname;
	    for (attrname in obj1) { obj3[attrname] = obj1[attrname]; }
	    for (attrname in obj2) { obj3[attrname] = obj2[attrname]; }
	    return obj3;
	  }
	
	  var introJs = function (targetElm) {
	    var instance;
	
	    if (typeof (targetElm) === 'object') {
	      //Ok, create a new instance
	      instance = new IntroJs(targetElm);
	
	    } else if (typeof (targetElm) === 'string') {
	      //select the target element with query selector
	      var targetElement = document.querySelector(targetElm);
	
	      if (targetElement) {
	        instance = new IntroJs(targetElement);
	      } else {
	        throw new Error('There is no element with given selector.');
	      }
	    } else {
	      instance = new IntroJs(document.body);
	    }
	    // add instance to list of _instances
	    // passing group to _stamp to increment
	    // from 0 onward somewhat reliably
	    introJs.instances[ _stamp(instance, 'introjs-instance') ] = instance;
	
	    return instance;
	  };
	
	  /**
	   * Current IntroJs version
	   *
	   * @property version
	   * @type String
	   */
	  introJs.version = VERSION;
	
	  /**
	  * key-val object helper for introJs instances
	  *
	  * @property instances
	  * @type Object
	  */
	  introJs.instances = {};
	
	  //Prototype
	  introJs.fn = IntroJs.prototype = {
	    clone: function () {
	      return new IntroJs(this);
	    },
	    setOption: function(option, value) {
	      this._options[option] = value;
	      return this;
	    },
	    setOptions: function(options) {
	      this._options = _mergeOptions(this._options, options);
	      return this;
	    },
	    start: function (group) {
	      _introForElement.call(this, this._targetElement, group);
	      return this;
	    },
	    goToStep: function(step) {
	      _goToStep.call(this, step);
	      return this;
	    },
	    addStep: function(options) {
	      if (!this._options.steps) {
	        this._options.steps = [];
	      }
	
	      this._options.steps.push(options);
	
	      return this;
	    },
	    addSteps: function(steps) {
	      if (!steps.length) return;
	
	      for(var index = 0; index < steps.length; index++) {
	        this.addStep(steps[index]);
	      }
	
	      return this;
	    },
	    goToStepNumber: function(step) {
	      _goToStepNumber.call(this, step);
	
	      return this;
	    },
	    nextStep: function() {
	      _nextStep.call(this);
	      return this;
	    },
	    previousStep: function() {
	      _previousStep.call(this);
	      return this;
	    },
	    exit: function(force) {
	      _exitIntro.call(this, this._targetElement, force);
	      return this;
	    },
	    refresh: function() {
	      _refresh.call(this);
	      return this;
	    },
	    onbeforechange: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introBeforeChangeCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onbeforechange was not a function');
	      }
	      return this;
	    },
	    onchange: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introChangeCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onchange was not a function.');
	      }
	      return this;
	    },
	    onafterchange: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introAfterChangeCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onafterchange was not a function');
	      }
	      return this;
	    },
	    oncomplete: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introCompleteCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for oncomplete was not a function.');
	      }
	      return this;
	    },
	    onhintsadded: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._hintsAddedCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onhintsadded was not a function.');
	      }
	      return this;
	    },
	    onhintclick: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._hintClickCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onhintclick was not a function.');
	      }
	      return this;
	    },
	    onhintclose: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._hintCloseCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onhintclose was not a function.');
	      }
	      return this;
	    },
	    onexit: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introExitCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onexit was not a function.');
	      }
	      return this;
	    },
	    onskip: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introSkipCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onskip was not a function.');
	      }
	      return this;
	    },
	    onbeforeexit: function(providedCallback) {
	      if (typeof (providedCallback) === 'function') {
	        this._introBeforeExitCallback = providedCallback;
	      } else {
	        throw new Error('Provided callback for onbeforeexit was not a function.');
	      }
	      return this;
	    },
	    addHints: function() {
	      _populateHints.call(this, this._targetElement);
	      return this;
	    },
	    hideHint: function (stepId) {
	      _hideHint.call(this, stepId);
	      return this;
	    },
	    hideHints: function () {
	      _hideHints.call(this);
	      return this;
	    },
	    showHint: function (stepId) {
	      _showHint.call(this, stepId);
	      return this;
	    },
	    showHints: function () {
	      _showHints.call(this);
	      return this;
	    },
	    removeHints: function () {
	      _removeHints.call(this);
	      return this;
	    },
	    removeHint: function (stepId) {
	      _removeHint.call(this, stepId);
	      return this;
	    },
	    showHintDialog: function (stepId) {
	      _showHintDialog.call(this, stepId);
	      return this;
	    }
	  };
	
	  return introJs;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

	(function(){
	if( !('ace' in window) ) window['ace'] = {}
	
	ace.config = {
	 storage_method: 0, //0 means use localStorage if available otherwise cookies, 1 means localStorage, 2 means cookies
	 cookie_expiry : 604800, //(cookie only) 1 week duration for saved settings
	 cookie_path: ''//(cookie only)
	}
	if( !('vars' in window['ace']) ) window['ace'].vars = {}
	ace.vars['very_old_ie']	= !('querySelector' in document.documentElement);
	
	ace.settings = {
		saveState : function(element, attrName, attrVal, append) {
			if( !element || (typeof element == 'string' && !(element = document.getElementById(element))) || !element.hasAttribute('id') ) return false;
			if( !ace.hasClass(element, 'ace-save-state') ) return false;
			
			var attrName = attrName || 'class';
			var id = element.getAttribute('id');
			
			var attrList = ace.data.get('state', 'id-'+id) || {};
			if(typeof attrList == 'string') {
				try {
					attrList = JSON.parse(attrList);
				}
				catch(e) {
					attrList = {}
				}
			}
	
			var newVal, hasCustomVal = typeof attrVal !== 'undefined', $delete = false;
			
			var re1 = /class/i
			var re2 = /checked|disabled|readonly|value/i
	
			if(re2.test(attrName)) newVal = hasCustomVal ? attrVal : element[attrName];
			else {
				if(element.hasAttribute(attrName)) {
					newVal = hasCustomVal ? attrVal : element.getAttribute(attrName);
				}
				else if(!hasCustomVal) $delete = true;
				//delete this, because element has no such attribute and we haven't given a custom value! (no attrVal)
			}
			
		
			if($delete) {
				delete attrList[attrName];
			}
			else {
				//save class names as an object which indicated which classes should be included or excluded (true/false)
				if( re1.test(attrName) ) {//class
				
					
					if( !attrList.hasOwnProperty(attrName) ) attrList[attrName] = {}
					if(append === true) {
						//append to previous value					
						attrList[attrName][newVal] = 1;
					}
					else if(append === false) {
						//remove from previous value
						attrList[attrName][newVal] = -1;
					}
					else {
						attrList[attrName]['className'] = newVal;
					}
				}
				
				else {
					attrList[attrName] = newVal;
				}
			}
			
			ace.data.set('state', 'id-'+id , JSON.stringify(attrList));
		},
		
		loadState : function(element, attrName) {
			if( !element || (typeof element == 'string' && !(element = document.getElementById(element))) || !element.hasAttribute('id') ) return false;
			
			var id = element.getAttribute('id');
			var attrList = ace.data.get('state', 'id-'+id) || {};
			if(typeof attrList == 'string') {
				try {
					attrList = JSON.parse(attrList);
				}
				catch(e) {
					attrList = {}
				}
			}
			
			var setAttr = function(element, attr, val) {
				var re1 = /class/i
				var re2 = /checked|disabled|readonly|value/i
				
				if(re1.test(attr)) {
					if(typeof val === 'object') {
						if('className' in val) element.setAttribute('class', val['className']);
						for(var key in val) if(val.hasOwnProperty(key)) {
							var append = val[key];
							if(append == 1) ace.addClass(element, key);
							else if(append == -1) ace.removeClass(element, key);
						}
					}
					//else if(typeof ace.addClass(element, val);
				}
				else if(re2.test(attr)) element[attr] = val;
				else element.setAttribute(attr, val);
			}
			
			if(attrName !== undefined) {
				if(attrList.hasOwnProperty(attrName) && attrList[attrName] !== null) setAttr(element, attrName, attrList[attrName]);
			}
			else {
				for(var name in attrList) {
					if(attrList.hasOwnProperty(name) && attrList[name] !== null) setAttr(element, name, attrList[name]);
				}
			}
		},
		
		clearState : function(element) {
			var id = null;
			if(typeof element === 'string') {
				id = element;
			}
			else if('hasAttribute' in element && element.hasAttribute('id')) {
				id = element.getAttribute('id');
			}
			if(id) ace.data.remove('state', 'id-'+id);
		}
	};
	
	
	
	
	(function() {
		//detect if it is supported
		//https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Detecting_CSS_animation_support
		var animationSupport = function() {
			var animation = false,
			animationstring = 'animation',
			keyframeprefix = '',
			domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
			pfx  = '',
			elm = document.createElement('div');
	
			if( elm.style.animationName !== undefined ) { animation = true; }    
	
			if( animation === false ) {
			  for( var i = 0; i < domPrefixes.length; i++ ) {
				if( elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
				  pfx = domPrefixes[ i ];
				  animationstring = pfx + 'Animation';
				  keyframeprefix = '-' + pfx.toLowerCase() + '-';
				  animation = true;
				  break;
				}
			  }
			}
			
			return animation;
		}
		
		ace.vars['animation'] = animationSupport();
		if( ace.vars['animation'] ) {
			//based on http://www.backalleycoder.com/2012/04/25/i-want-a-damnodeinserted/
	
			var animationCSS = "@keyframes nodeInserted{from{outline-color:#fff}to{outline-color:#000}}@-moz-keyframes nodeInserted{from{outline-color:#fff}to{outline-color:#000}}@-webkit-keyframes nodeInserted{from{outline-color:#fff}to{outline-color:#000}}@-ms-keyframes nodeInserted{from{outline-color:#fff}to{outline-color:#000}}@-o-keyframes nodeInserted{from{outline-color:#fff}to{outline-color:#000}}.ace-save-state{animation-duration:10ms;-o-animation-duration:10ms;-ms-animation-duration:10ms;-moz-animation-duration:10ms;-webkit-animation-duration:10ms;animation-delay:0s;-o-animation-delay:0s;-ms-animation-delay:0s;-moz-animation-delay:0s;-webkit-animation-delay:0s;animation-name:nodeInserted;-o-animation-name:nodeInserted;-ms-animation-name:nodeInserted;-moz-animation-name:nodeInserted;-webkit-animation-name:nodeInserted}";
			var animationNode = document.createElement('style');
			animationNode.innerHTML = animationCSS;
			document.head.appendChild(animationNode);
		
			var domInsertEvent = function(event) {
				var element = event.target;
				if( !element || !ace.hasClass(element, 'ace-save-state') ) return;
				
				ace.settings.loadState(element);
			}
	
			document.addEventListener('animationstart', domInsertEvent, false);
			document.addEventListener('MSAnimationStart', domInsertEvent, false);
			document.addEventListener('webkitAnimationStart', domInsertEvent, false);
		}
		else {
			//if animation events are not supported, wait for document ready event
			var documentReady = function() {
				var list = document.querySelectorAll('.ace-save-state');
				for(var i = 0 ; i < list.length ; i++) ace.settings.loadState(list[i]);
			}
			
			if(document.readyState == 'complete') documentReady();
			else if(document.addEventListener) document.addEventListener('DOMContentLoaded', documentReady, false);
			else if(document.attachEvent) document.attachEvent('onreadystatechange', function(){
				if (document.readyState == 'complete') documentReady();
			});
		}
	})();
	
	
	
	
	
	
	//save/retrieve data using localStorage or cookie
	//method == 1, use localStorage
	//method == 2, use cookies
	//method not specified, use localStorage if available, otherwise cookies
	ace.data_storage = function(method, undefined) {
		var prefix = 'ace_';
	
		var storage = null;
		var type = 0;
		
		if((method == 1 || method === undefined || method == 0) && 'localStorage' in window && window['localStorage'] !== null) {
			storage = ace.storage;
			type = 1;
		}
		else if(storage == null && (method == 2 || method === undefined) && 'cookie' in document && document['cookie'] !== null) {
			storage = ace.cookie;
			type = 2;
		}
		
	
		this.set = function(namespace, key, value, path, is_obj, undefined) {
			if(!storage) return;
			
			if(value === undefined) {//no namespace here?
				value = key;
				key = namespace;
	
				if(value == null) storage.remove(prefix+key)
				else {
					if(type == 1)
						storage.set(prefix+key, value)
					else if(type == 2)
						storage.set(prefix+key, value, ace.config.cookie_expiry, path || ace.config.cookie_path)
				}
			}
			else {
				if(type == 1) {//localStorage
					if(value == null) storage.remove(prefix+namespace+'_'+key)
					else {
						if(is_obj && typeof value == 'object') {
							value = JSON.stringify(value);
						}
						storage.set(prefix+namespace+'_'+key, value);
					}
				}
				else if(type == 2) {//cookie
					var val = storage.get(prefix+namespace);
					var tmp = val ? JSON.parse(val) : {};
	
					if(value == null) {
						delete tmp[key];//remove
						if(ace.sizeof(tmp) == 0) {//no other elements in this cookie, so delete it
							storage.remove(prefix+namespace);
							return;
						}
					}
					
					else {
						tmp[key] = value;
					}
	
					storage.set(prefix+namespace , JSON.stringify(tmp), ace.config.cookie_expiry, path || ace.config.cookie_path)
				}
			}
		}
	
		this.get = function(namespace, key, is_obj, undefined) {
			if(!storage) return null;
			
			if(key === undefined) {//no namespace here?
				key = namespace;
				return storage.get(prefix+key);
			}
			else {
				if(type == 1) {//localStorage
					var value = storage.get(prefix+namespace+'_'+key);
					if(is_obj && value) {
						try { value = JSON.parse(value) } catch(e) {}
					}
					return value;
				}
				else if(type == 2) {//cookie
					var val = storage.get(prefix+namespace);
					var tmp = val ? JSON.parse(val) : {};
					return key in tmp ? tmp[key] : null;
				}
			}
		}
	
		
		this.remove = function(namespace, key, undefined) {
			if(!storage) return;
			
			if(key === undefined) {
				key = namespace
				this.set(key, null);
			}
			else {
				this.set(namespace, key, null);
			}
		}
	}
	
	
	
	
	
	//cookie storage
	ace.cookie = {
		// The following settingFunction are from Cookie.js class in TinyMCE, Moxiecode, used under LGPL.
	
		/**
		 * Get a cookie.
		 */
		get : function(name) {
			var cookie = document.cookie, e, p = name + "=", b;
	
			if ( !cookie )
				return;
	
			b = cookie.indexOf("; " + p);
	
			if ( b == -1 ) {
				b = cookie.indexOf(p);
	
				if ( b != 0 )
					return null;
	
			} else {
				b += 2;
			}
	
			e = cookie.indexOf(";", b);
	
			if ( e == -1 )
				e = cookie.length;
	
			return decodeURIComponent( cookie.substring(b + p.length, e) );
		},
	
		/**
		 * Set a cookie.
		 *
		 * The 'expires' arg can be either a JS Date() object set to the expiration date (back-compat)
		 * or the number of seconds until expiration
		 */
		set : function(name, value, expires, path, domain, secure) {
			var d = new Date();
	
			if ( typeof(expires) == 'object' && expires.toGMTString ) {
				expires = expires.toGMTString();
			} else if ( parseInt(expires, 10) ) {
				d.setTime( d.getTime() + ( parseInt(expires, 10) * 1000 ) ); // time must be in miliseconds
				expires = d.toGMTString();
			} else {
				expires = '';
			}
	
			document.cookie = name + "=" + encodeURIComponent(value) +
				((expires) ? "; expires=" + expires : "") +
				((path) ? "; path=" + path : "") +
				((domain) ? "; domain=" + domain : "") +
				((secure) ? "; secure" : "");
		},
	
		/**
		 * Remove a cookie.
		 *
		 * This is done by setting it to an empty value and setting the expiration time in the past.
		 */
		remove : function(name, path) {
			this.set(name, '', -1000, path);
		}
	};
	
	
	//local storage
	ace.storage = {
		get: function(key) {
			return window['localStorage'].getItem(key);
		},
		set: function(key, value) {
			window['localStorage'].setItem(key , value);
		},
		remove: function(key) {
			window['localStorage'].removeItem(key);
		}
	};
	
	
	
	
	
	
	//count the number of properties in an object
	//useful for getting the number of elements in an associative array
	ace.sizeof = function(obj) {
		var size = 0;
		for(var key in obj) if(obj.hasOwnProperty(key)) size++;
		return size;
	}
	
	//because jQuery may not be loaded at this stage, we use our own toggleClass
	ace.hasClass = function(elem, className) {	return (" " + elem.className + " ").indexOf(" " + className + " ") > -1; }
	
	ace.addClass = function(elem, className) {
	 var parts = className.split(/\s+/);
	 for(var p = 0; p < parts.length; p++) {
		if ( parts[p].length > 0 && !ace.hasClass(elem, parts[p]) ) {
			var currentClass = elem.className;
			elem.className = currentClass + (currentClass.length ? " " : "") + parts[p];
		}
	 }
	}
	
	ace.removeClass = function(elem, className) {
	 var parts = className.split(/\s+/);
	 for(var p = 0; p < parts.length; p++) {
		if( parts[p].length > 0 ) ace.replaceClass(elem, parts[p]);
	 }
	 ace.replaceClass(elem, className);
	}
	
	ace.replaceClass = function(elem, className, newClass) {
	 var classToRemove = new RegExp(("(^|\\s)" + className + "(\\s|$)"), "i");
	 elem.className = elem.className.replace(classToRemove, function (match, p1, p2) {
		return newClass ? (p1 + newClass + p2) : " ";
	 }).replace(/^\s+|\s+$/g, "");
	}
	
	
	ace.toggleClass = function(elem, className) {
		if(ace.hasClass(elem, className))
			ace.removeClass(elem, className);
		else ace.addClass(elem, className);
	}
	
	ace.isHTMlElement = function(elem) {
	 return window.HTMLElement ? elem instanceof HTMLElement : ('nodeType' in elem ? elem.nodeType == 1 : false);
	}
	
	
	 //data_storage instance used inside ace.settings etc
	 ace.data = new ace.data_storage(ace.config.storage_method);
	
	})();
	


/***/ })

/******/ });


// WEBPACK FOOTER //
// javascripts/user-common-js/header.js